module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/original-logo@3x-6d419bbcbcce57d8cac3b6d4ec703c43.png";